<div class="flex mb-3" *ngIf="reportItem">
    <div class="mr-2"><i (click)=toggleFavourite(reportItem) class="pi pi-star-fill"
            [ngClass]="reportItem?.isFavourite ? 'strFCl' : 'strFGr'"></i></div>
    <div>
        <div class="mb-1">
            <!--<a class="BlTxt" routerLink="/report-details">{{reportItem.reportName}}</a>-->
            <ng-container *ngIf="reportItem?.childReport; else userReportLink">
                <a class="BlTxt" routerLink="/report-details/{{reportItem?.id}}/0">{{reportItem?.reportName}}</a>
            </ng-container>
            <ng-template #userReportLink>
                <a *ngIf="currentTab==2 else scheduleReportLink" class="BlTxt"
                    routerLink="/report-details/{{(reportItem?.savedReport) ? reportItem?.savedReport?.reportId : reportItem?.id}}/{{reportItem?.savedReportId}}">{{reportItem?.reportName}}</a>
                <ng-template #scheduleReportLink>
                    <a class="BlTxt"
                        routerLink="/report-details/{{reportItem?.reportId}}/{{reportItem?.id}}">{{reportItem?.reportName}}
                        <!-- <i class="pi pi-chart-bar ml-1" *ngIf="reportItem?.isSummarized == reportType.GRAPH_REPORT"></i> -->
                    </a>
                </ng-template>
            </ng-template>
            <!-- strFCl  strFGr -->
            <!--<a (click)="visible1 = true" class="imgCls"
                pTooltip="Report Security" tooltipPosition="top"><img
                    src="assets/images/report-security.svg" alt=""
                    class="icnImg"></a>-->
            <span *ngIf="reportItem?.isSummarized == reportType.GRAPH_REPORT" class="ml-2 activeIcon" pTooltip="Graph Report"
                tooltipPosition="top"><img src="assets/images/graph-icon.svg" alt="" class=" activeIcon"></span>
            <span *ngIf="reportItem?.isTaggedReport && [0,1].includes(currentTab) && reportItem?.isAdminReport == 1" class="ml-2 activeIcon" pTooltip="Tagged Report"
                tooltipPosition="top"><img src="assets/images/tag-icon-light.svg" alt="" class=" activeIcon"></span>
            <span *ngIf="reportItem?.isScheduledReport && [0,1].includes(currentTab)" class="ml-2 activeIcon" pTooltip="Scheduled Report"
                tooltipPosition="top"><img src="assets/images/scheduleReport-icon.svg" alt="" class=" activeIcon"></span>
                <a *ngIf="reportItem?.isReportLevelSecurity" class="imgCls" pTooltip="Scheduled Report"
                tooltipPosition="top"><img src="assets/images/scheduleReport-icon.svg" alt="" class="icnImg activeIcon"></a>
            <!--<a (click)="visible2 = true" class="imgCls"
                pTooltip="Scheduled Report" tooltipPosition="top"><img
                    src="assets/images/clock-icon.svg" alt=""
                    class="icnImg"></a>-->
        </div>
        <div class="mb-1 sbTxt">{{reportItem?.reportDesc}}</div>
        <div class="sbTxtblc"> {{currentTab==2 ? 'Scheduled by' : 'Created by'}}
            <span class="smBld" *ngIf="reportItem?.isAdminReport">System</span>
            <span class="smBld" *ngIf="!reportItem?.isAdminReport">{{reportItem?.createdBy}}</span> on
            <span class="smBld sbTxtFt">{{reportItem?.createdAt}}</span>
            
        </div>
        <div class="sbTxtblc" *ngIf="currentTab==0"> Updated by
            <span class="smBld" *ngIf="!reportItem?.isAdminReport">{{reportItem?.updatedBy}}</span> on
            <span class="smBld sbTxtFt">{{reportItem?.updatedAt}}</span>
        </div>
    </div>
    <div class="ml-auto dotV"><a id="dropDownL" (click)="menu.toggle($event)"><i class="pi pi-ellipsis-v"></i></a></div>

    <div class="menuMd">
        <p-menu [model]="items" [popup]="true" #menu>
            <ng-template let-item pTemplate="item">
                <a class="flex">
                    <img [src]="item.image" width="20" style="margin-right: 8px;" class="menuImg">
                    <div class="menulab"> {{ item.label }} </div>
                </a>
            </ng-template>
        </p-menu>
    </div>
</div>

<!-- PrimeNG Confirmation Dialog -->
<p-confirmDialog></p-confirmDialog>